<template>
  <div class="h-screen w-screen flex bg-background text-foreground">
    <section class="flex-1 flex flex-col border-r border-border">
      <header
        class="py-6 text-center bg-muted text-muted-foreground uppercase tracking-widest text-3xl font-bold"
      >
        {{ t('customer-display.preparing') }}
      </header>
      <div class="flex-1 flex flex-wrap content-start gap-6 p-8 overflow-y-auto justify-center">
        <div
          v-for="tab in preparingTabs"
          :key="tab.tabId"
          class="bg-muted text-foreground rounded-2xl flex items-center justify-center p-8 text-[5rem] font-extrabold tracking-wider leading-none"
        >
          {{ tab.code?.toUpperCase() }}
        </div>
      </div>
    </section>

    <section class="flex-1 flex flex-col">
      <header
        class="py-6 text-center bg-success text-success-foreground uppercase tracking-widest text-3xl font-bold"
      >
        {{ t('customer-display.ready') }}
      </header>
      <div class="flex-1 flex flex-wrap content-start gap-6 p-8 overflow-y-auto justify-center">
        <div
          v-for="tab in readyTabs"
          :key="tab.tabId"
          class="bg-success text-success-foreground rounded-2xl flex items-center justify-center p-8 text-[5rem] font-extrabold tracking-wider leading-none"
        >
          {{ tab.code?.toUpperCase() }}
        </div>
      </div>
    </section>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, onUnmounted } from 'vue'
import { useI18n } from 'vue-i18n'

import { useTabsStore } from '@/store/tabs'

const { t } = useI18n()
const tabsStore = useTabsStore()

const visibleTabs = computed(() => tabsStore.tabs.filter(tab => tab.code))

const preparingTabs = computed(() =>
  visibleTabs.value.filter(tab => tab.status?.name?.toUpperCase() === 'KITCHEN')
)

const readyTabs = computed(() =>
  visibleTabs.value.filter(tab => tab.status?.name?.toUpperCase() === 'READY_TO_PICKUP')
)

async function requestFullscreen() {
  if (!document.fullscreenEnabled || document.fullscreenElement) return
  try {
    await document.documentElement.requestFullscreen()
  } catch {
    // user gesture not yet granted; fallback listener handles it
  }
}

function onUserGesture() {
  void requestFullscreen()
}

onMounted(() => {
  tabsStore.refreshTabs()
  if (import.meta.env.DEV) return
  void requestFullscreen()
  window.addEventListener('pointerdown', onUserGesture, { once: true })
  window.addEventListener('keydown', onUserGesture, { once: true })
})

onUnmounted(() => {
  if (import.meta.env.DEV) return
  window.removeEventListener('pointerdown', onUserGesture)
  window.removeEventListener('keydown', onUserGesture)
})
</script>
